export enum Frequency {
  IRREGULAR = 'Irregular',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  BIANNUAL = 'Biannual',
  TRIANNUAL = 'Triannual',
  YEARLY = 'Yearly'
}
